import React from 'react';
import {
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Area,
  AreaChart,
} from 'recharts';
import { ChartDataPoint } from '../data/chart-data';

const CustomTooltip = ({ active, payload, label }: any) => {
  if (active && payload && payload.length) {
    return (
      <div className="bg-white p-3 border border-gray-200 rounded-lg shadow-lg">
        <p className="font-semibold text-gray-800">{`${label}`}</p>
        <p className="text-blue-600 font-medium">
          {`Clients: ${payload[0].value.toLocaleString()}`}
        </p>
      </div>
    );
  }
  return null;
};

interface NewClientsChartProps {
  data?: ChartDataPoint[];
  dateRange?: [any, any];
}

const NewClientsChart: React.FC<NewClientsChartProps> = ({ data = [], dateRange }) => {
  const formatDateRange = () => {
    if (dateRange && dateRange[0] && dateRange[1]) {
      return `${dateRange[0].format('MMM YYYY')} - ${dateRange[1].format('MMM YYYY')}`;
    }
    return 'All time';
  };

  return (
    <div className="w-full h-[400px] p-6">
      {dateRange && (dateRange[0] || dateRange[1]) && (
        <div className="mb-4 text-sm text-gray-600 text-center">
          Showing data for: <span className="font-semibold">{formatDateRange()}</span>
          {data.length > 0 && (
            <span className="ml-2 text-gray-500">
              ({data.length} data points)
            </span>
          )}
        </div>
      )}
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart
          data={data}
          margin={{
            top: 20,
            right: 30,
            left: 20,
            bottom: 20,
          }}
        >
          <defs>
            <linearGradient id="colorClients" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#407097" stopOpacity={0.3}/>
              <stop offset="95%" stopColor="#407097" stopOpacity={0.05}/>
            </linearGradient>
          </defs>
          <CartesianGrid 
            strokeDasharray="3 3" 
            stroke="#E5E7EB" 
            vertical={false}
          />
          <XAxis 
            dataKey="month" 
            axisLine={false}
            tickLine={false}
            tick={{ fontSize: 12, fill: '#6B7280' }}
            tickMargin={10}
          />
          <YAxis 
            axisLine={false}
            tickLine={false}
            tick={{ fontSize: 12, fill: '#6B7280' }}
            tickMargin={10}
            ticks={[0, 500, 1000, 1500, 2000]}
            tickFormatter={(value) => {
              if (value === 1000) return '1,000';
              if (value === 1500) return '1,500';
              if (value === 2000) return '2,000';
              return value.toString();
            }}
          />
          <Tooltip content={<CustomTooltip />} />
          <Area
            type="monotone"
            dataKey="clients"
            stroke="#407097"
            strokeWidth={3}
            fill="url(#colorClients)"
            dot={{
              fill: '#407097',
              stroke: '#FFFFFF',
              strokeWidth: 2,
              r: 4,
            }}
            activeDot={{
              r: 6,
              stroke: '#407097',
              strokeWidth: 2,
              fill: '#FFFFFF',
            }}
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
};

export default NewClientsChart; 